import React, { useEffect } from 'react';
import { useGame } from '../context/GameContext';
import { Sparkles } from 'lucide-react';
import { RARITY_COLORS } from '../game/blessings';
import { sfx } from '../game/sound';

export default function BlessingPick() {
  const { pendingBlessing, takeBlessing } = useGame();
  useEffect(() => {
    // v2.3: play a legendary chime if any offer is legendary
    if (pendingBlessing && (pendingBlessing.offers || []).some(o => o.rarity === 'legendary')) {
      try { sfx.legendaryChime && sfx.legendaryChime(); } catch (e) {}
    }
  }, [pendingBlessing]);
  if (!pendingBlessing) return null;
  const { offers, floorIdx } = pendingBlessing;

  return (
    <div className="min-h-screen w-full px-6 py-8 flex flex-col items-center justify-center gap-6" data-testid="blessing-screen">
      <div className="text-center">
        <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]" data-testid="blessing-header-subtitle">
          FLOOR {(floorIdx || 0) + 1} · MID-BOSS DEFEATED
        </div>
        <h1 className="font-display text-4xl sm:text-6xl font-black uppercase text-[color:var(--pink)] mt-2">
          BOSS BLESSING
        </h1>
        <div className="text-xs uppercase tracking-widest text-[color:var(--text-dim)] mt-2 max-w-lg mx-auto">
          Choose one permanent buff for the rest of your run
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-5xl w-full" data-testid="blessing-offers">
        {offers.map((b) => {
          const color = RARITY_COLORS[b.rarity] || '#a0ff2e';
          return (
            <button
              key={b.id}
              onClick={() => takeBlessing(b.id)}
              className="blessing-card brutal-border p-6 bg-[#0a0a0a] flex flex-col items-center gap-4 text-center hover:translate-x-[-3px] hover:translate-y-[-3px] transition-transform relative overflow-hidden"
              data-testid={`blessing-choice-${b.id}`}
              data-rarity={b.rarity}
              style={{ borderColor: color, boxShadow: `6px 6px 0 ${color}` }}
            >
              {b.rarity === 'legendary' && (
                <div className="absolute inset-0 pointer-events-none legendary-shimmer" aria-hidden />
              )}
              <div className="text-[10px] uppercase tracking-widest font-mono" style={{ color }} data-testid={`blessing-rarity-${b.id}`}>
                {b.rarity}
              </div>
              <div className="text-6xl" style={{ filter: `drop-shadow(0 0 12px ${color}88)` }}>{b.art}</div>
              <div className="font-display font-black text-2xl uppercase" style={{ color }}>{b.name}</div>
              <div className="text-sm text-[color:var(--text-dim)] leading-relaxed">{b.desc}</div>
              <div className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-[color:var(--neon)] font-mono">
                <Sparkles size={12}/> PERMANENT
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
